import React, { useEffect, useState } from 'react';
import { useRouteMatch } from "react-router-dom";
//ACTIONS AND CONTEXT
import { useMainContext } from "../../../contexts/MainContext";
//COMPONENTS
import ButtonModalFiles from '../../molecules/ButtonModalFiles';
//ASSETS
import ventasImg from '../../../assets/icons/icon-ventas.svg';
import ventasWhiteImg from '../../../assets/icons/icon-ventas-white.svg';
import homeImg from '../../../assets/icons/icon-home.svg';

const MenuPhases = ({ linkActive, phaseID, phaseData, hasUnits }) => {
    let mainContext = useMainContext();
    let { path } = useRouteMatch();

    const [phaseName, setPhaseName] = useState("");

    useEffect(() => {
        mainContext.setIsDirty(false);
    }, []);

    useEffect(() => {
        if (phaseData.phaseID)
            setTitle();
        else
            createTitle();
    }, [phaseData]);

    const setTitle = () => {
        let name = "COMPLEJO - NUEVA TORRE";
        if (phaseData.developerComplex)
            name = phaseData.developerComplex.complex.complexName;
        name += " - " + phaseData.phaseName;
        setPhaseName(name);
    }

    const createTitle = () => {
        let name = "COMPLEJO - NUEVA TORRE";
        if (phaseData.complexID)
            name = phaseData.complexID.complexName;
        if (phaseData.complexID)
            name += " - " + phaseData.phaseName;
        setPhaseName(name);
    }

    const requestNavigation = (goTo) => {
        let goToArr = goTo.split("/");
        let pathArr = path.split("/");
        if (goToArr[goToArr.length - 1] == pathArr[pathArr.length - 1])
            return;
        if (phaseID || goTo === "/#home")
            mainContext.setGoTo(goTo);
    }

    //Menu
    const getCSSClass = (link) => {
        let _className = "";
        if (linkActive == link)
            _className += "active-tab ";
        if (!phaseID)
            _className += "disabled";
        //_className = "btn btn-white mr-3 btn-submenu ";

        return _className;
    }

    return (
        <>
            <div className="row">
                <h2 className="col py-5 break-word">{phaseName}</h2>
            </div>
            <div className="row mb-5">
                <div className="col col-8">
                    <div className={`nav nav-fill`}>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("/#phase/general") }} className={`nav-link pointer ${getCSSClass("general")}`}><span>General</span></a>
                        </div>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("/#phase/amenidades") }} className={`nav-link pointer ${getCSSClass("amenidades")}`}><span>Amenidades</span></a>
                        </div>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("/#phase/especificaciones") }} className={`nav-link pointer ${getCSSClass("especificaciones")}`}><span>Especificaciones</span></a>
                        </div>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("/#phase/models") }} className={`nav-link pointer ${getCSSClass("modelos")}`} to="/"><span>Modelos</span></a>
                        </div>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("/#phase/stories") }} className={`nav-link pointer ${getCSSClass("pisos")}`} to="/"><span>Pisos</span></a>
                        </div>
                        <div className="nav-item">
                            <a onClick={() => { if (phaseData.hasUnits || hasUnits) requestNavigation("/#phase/units") }} className={`nav-link pointer ${getCSSClass("unidades")}`} to="/"><span>Unidades</span></a>
                        </div>
                    </div>
                </div>
                <div className="col col-4">
                    <div className="d-flex justify-content-end">
                        <ButtonModalFiles phaseID={phaseID} projectID={(phaseData.projects) ? phaseData.projects.projectID : null} />
                        <button onClick={() => { requestNavigation("/#phase/salesStatus") }} className={`btn btn-white mr-3 btn-submenu ${getCSSClass("ventas")}`}>
                            <img className="active" src={ventasWhiteImg} alt="" />
                            <img className="no-active" src={ventasImg} alt="" />
                        </button>
                        <button onClick={() => { requestNavigation("/#home") }} className="btn btn-white btn-submenu">
                            <img className="" src={homeImg} alt="" />
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default MenuPhases;